module.exports = __webpack_public_path__ + "assets/img/ISO_27001_Certified_by_NIXU.7b115dab.png";